import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthUtils } from './auth.utils';
import { AuthService } from './auth.service';
import { DeviceInfo } from 'src/app/models/device-info';
import { Device } from '@capacitor/device';
import { Capacitor } from '@capacitor/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptor implements HttpInterceptor {
  private deviceInfo: DeviceInfo;
  /**
   * Constructor
   */
  constructor(private readonly _authService: AuthService) {
    this.initDeviceInfo();
  }

  private async initDeviceInfo() {
    if (Capacitor.isNativePlatform()) {
      const uid = await Device.getId();
      const info = await Device.getInfo();

      this.deviceInfo = {
        appVersion: environment.version,
        deviceOS: info.osVersion,
        deviceId: uid.identifier,
        deviceType: info.platform,
        device: info.name,
      };
    } else {
      // Información básica para plataformas web
      this.deviceInfo = {
        device: 'Web Browser',
        deviceType: 'web',
        deviceId: 'unknown',
        deviceOS: navigator.userAgent,
        appVersion: environment.version,
      };
    }
  }

  /**
   * Intercept
   *
   * @param req
   * @param next
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Clonar la solicitud original
    let newReq = req.clone();

    // Agregar la información del dispositivo si está disponible
    if (this.deviceInfo) {
      newReq = newReq.clone({
        setHeaders: {
          'Device-Info': JSON.stringify(this.deviceInfo)
        }
      });
    }
    
    // Agregar el token de autorización si está disponible y no ha expirado
    if (this._authService.accessToken && !AuthUtils.isTokenExpired(this._authService.expiresIn)) {
      newReq = newReq.clone({
        headers: newReq.headers.set('Authorization', 'Bearer ' + this._authService.accessToken),
      });
    }

    // Manejar la respuesta
    return next.handle(newReq).pipe(
      catchError((error) => {
        // Capturar respuestas "401 No autorizado"
        if (error instanceof HttpErrorResponse && error.status === 401) {
          // Cerrar sesión
          this._authService.signOut();

          // Recargar la aplicación
          location.reload();
        }

        return throwError(() => error);
      }),
    );
  }
}
